/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React from "react"
import Dialog from "../../components/Dialog"
import { connect } from "react-redux"
import "./save.css"

import * as act from "./actions"
import { TRCButton } from "../../trace"

class JumpToClipDialog extends Dialog {
    constructor(props) {
        super(props)
        this.showTraceId = this.showTraceId.bind(this)
        this.removeClipFromTraceId = this.removeClipFromTraceId.bind(this)
        this.toggleRemoval = this.toggleRemoval.bind(this)
        this.state = {
            inRemove: false,
            userPlaylist: null,
        }
    }

    componentDidMount() {
        super.componentDidMount()
        let event = new CustomEvent("trc-pause")
        document.dispatchEvent(event)
        this.enableLock()
    }

    componentWillUnmount() {
        super.componentDidMount()
        this.disableLock()
    }

    get addClassName() {
        return "sheet-dialog"
    }

    get title() {
        return <h2>MY MOMENT</h2>
    }

    get dismissUrl() {
        return window.location.hash
            .replace(/^#/gi, "")
            .replace(/\/jump\/profile\/confirm$/gi, "")
    }

    get content() {
        if (!this.props.user) {
            return null
        }

        return (
            <div className="jump-to-id-content">
                <div className="text">
                    This moment is currently on your Trace iD.
                </div>
                <div className="dialog-actions">
                    <TRCButton
                        trkAction="Open Trace iD"
                        onClick={this.showTraceId}
                        full
                    >
                        See it on my Trace iD
                    </TRCButton>
                    {!this.state.inRemove && (
                        <TRCButton
                            trkAction="Remove Clip Pressed"
                            onClick={this.toggleRemoval}
                            full
                            secondary
                            whoops
                        >
                            Remove from Trace iD
                        </TRCButton>
                    )}
                    {this.state.inRemove && (
                        <div className="confirm">
                            <span onClick={this.removeClipFromTraceId}>
                                Yes, remove
                            </span>
                            <div className="separator" />
                            <span onClick={this.toggleRemoval}>
                                Do not remove
                            </span>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    showTraceId() {
        window.location.href = `https://id.traceup.com/find/user/${this.props.user.user_id}`
    }

    toggleRemoval() {
        this.setState({ inRemove: !this.state.inRemove })
    }

    removeClipFromTraceId() {
        if (this.props.clip) {
            this.props.deleteClip(this.props.user, this.props.clip, () => {
                this.close()
            })
        }
    }
}

const mapStateToProps = (state, pageProps) => {
    let user = state.user.value
    return {
        user: user,
        returnUrl: window.location.href,
        clip: state.video.value.source,
        rev: new Date().getTime(),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deleteClip: (user, clip, cb) => {
            dispatch(act.deleteClipFromPlaylist(user, clip, cb))
        },
    }
}

export const JumpToTraceIdDialog = connect(
    mapStateToProps,
    mapDispatchToProps
)(JumpToClipDialog)
